import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-6 py-8 px-5 bg-white form-float-box-border text-racq-dark-grey" }
const _hoisted_2 = { class: "text-xl !font-medium leading-7 mb-2" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "w-full md:w-auto xl:w-full h-8 px-4 py-2 bg-racq-anti-flash-white rounded-lg justify-center items-start gap-5 inline-flex" }
const _hoisted_5 = { class: "text-center text-racq-med-grey text-xs leading-none" }
const _hoisted_6 = { class: "sticky-modal-header" }
const _hoisted_7 = ["innerHTML"]

import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue';
import { Item } from '@sitecore-jss/sitecore-jss/layout';
import { getDiscountsList } from '@/utils/iq-discounts';
import { IQuote } from '@/interfaces';
import DollarAmount from '@/components/DollarAmount/DollarAmount.vue';
import TagList from '@/components/TagList/TagList.vue';
import { TagTypes, TagOrientation, TagSize } from '@/enums/tag-enums';
import ModalDialog from '../ModalDialog/ModalDialog.vue';
import PaymentFrequencyDropdown from '../PaymentFrequencyDropdown/PaymentFrequencyDropdown.vue';
import { PaymentFrequency } from '@/enums/payment-frequency';
import { usePaymentStore } from '@/store';

enum fieldNames {
  title = 'Title',
  annualPayment = 'Annual Payment',
  monthlyPayment = 'Monthly Payment',
  refNumber = 'Ref Number',
  quoteChangedLink = 'Quote Changed Link',
  whyHasMyQuoteChangedModal = 'Why Has My Quote Changed Modal',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IQFloatingBox',
  props: {
    fields: {},
    testParams: {}
  },
  setup(__props: any) {

const props = __props;

const { t, getLocaleMessage } = useI18n();
const showWhyQuoteChangedModal = ref<boolean>(false);
const whyHasQuoteChangeModal = ref<any>();

const getFieldByName = (fieldName: fieldNames) => {
  if (!props.fields.floatingBoxContext?.fields) return;
  const fields = props.fields.floatingBoxContext.fields ? props.fields.floatingBoxContext.fields : [];
  const field = (fields as any[]).find((x: any) => x.name === fieldName);
  return field;
};

const wordings = computed(() => ({
  title: getFieldByName(fieldNames.title)?.content,
  annual: getFieldByName(fieldNames.annualPayment)?.content,
  monthly: getFieldByName(fieldNames.monthlyPayment)?.content,
  refNum: getFieldByName(fieldNames.refNumber)?.content,
}));

const premiumHasChangeLink = ref<any>();
const paymentStore = usePaymentStore();

const referenceNumberText = computed(() => {
  return `${wordings.value.refNum.value} ${props.fields.quote?.reference}`;
});
const insuranceQuoteSummary = computed(() =>
  paymentStore.selectedPaymentFrequency === PaymentFrequency.Annually
    ? props.fields.quote?.insuranceQuoteSummary?.yearlyAnnualPremium
    : props.fields.quote?.insuranceQuoteSummary?.monthlyDeposit
);

const discounts = computed(() =>
  getDiscountsList({ t, getLocaleMessage }, props.fields.quote, {
    showAsMonthly: paymentStore.selectedPaymentFrequency === PaymentFrequency.Monthly,
    showOnlineDiscount: props.fields.showOnlineDiscount,
    showOnlineDiscountLast: props.fields.showOnlineDiscountLast,
  })
);

const quoteHasChanged = computed(() => {
  return props.fields.hasPremiumChanged;
});

onMounted(async () => {
  paymentStore.paymentFrequencyWording = { annual: wordings.value.annual.value, monthly: wordings.value.monthly.value };

  premiumHasChangeLink.value = getFieldByName(fieldNames.quoteChangedLink)?.content;
  whyHasQuoteChangeModal.value = getFieldByName(fieldNames.whyHasMyQuoteChangedModal)?.datasource;
});

function onModalClose(e: any) {
  showWhyQuoteChangedModal.value = e;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, [
        _createVNode(_unref(Text), {
          field: wordings.value.title
        }, null, 8, ["field"])
      ]),
      _createVNode(DollarAmount, {
        showStarSign: false,
        amount: insuranceQuoteSummary.value ?? ''
      }, null, 8, ["amount"]),
      (_unref(paymentStore).paymentFrequencyWording)
        ? (_openBlock(), _createBlock(PaymentFrequencyDropdown, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TagList, {
          tags: discounts.value,
          tagType: _unref(TagTypes).discount,
          tagSize: _unref(TagSize).sm,
          tagOrientation: _unref(TagOrientation).vertical,
          innerClass: "w-fit"
        }, null, 8, ["tags", "tagType", "tagSize", "tagOrientation"])
      ]),
      (quoteHasChanged.value || props.testParams?.enableQuoteHasChanged)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "link text-m",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showWhyQuoteChangedModal.value = true))
          }, [
            _createVNode(_unref(RichText), {
              class: "flex flex-col space-y-3 text-m mb-6",
              field: { value: premiumHasChangeLink.value?.value }
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(referenceNumberText.value), 1)
      ])
    ]),
    _createVNode(ModalDialog, {
      modelValue: showWhyQuoteChangedModal.value,
      showXCloseButton: true,
      closeOnEsc: false,
      size: "tooltip",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => onModalClose(value))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(whyHasQuoteChangeModal.value?.fields['modalTitle']?.value), 1),
        _createElementVNode("div", {
          class: "tooltip-body richtext",
          innerHTML: whyHasQuoteChangeModal.value?.fields['modalBody']?.value
        }, null, 8, _hoisted_7)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})